import useSWR from 'swr';

import { fetchInvestmentOverview, type InvestmentOverview } from '../data/investmentRepository.js';

export type InvestmentOverviewState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; data: InvestmentOverview };

export function useInvestmentOverview(
  subjectId: string | null,
  year: number,
): InvestmentOverviewState {
  const key = subjectId === null ? null : `investment-overview:${subjectId}:${year}`;
  const { data, error, isLoading, mutate } = useSWR<InvestmentOverview, Error>(
    key,
    () => fetchInvestmentOverview(subjectId!, year),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (key === null) return { status: 'idle' };
  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được dữ liệu đầu tư.',
      retry: () => {
        void mutate();
      },
    };
  }
  if (isLoading || data === undefined) return { status: 'loading' };
  return { status: 'ready', data };
}
